import { marked } from 'marked'
import DOMPurify from 'dompurify'

// Model output is untrusted. Sanitize the final HTML before passing it to v-html.
export function renderMarkdown(content: string): string {
  const html = marked.parse(content, { async: false, breaks: true, gfm: true })
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'del', 'ul', 'ol', 'li', 'blockquote',
      'code', 'pre', 'a', 'h1', 'h2', 'h3', 'h4', 'hr',
      'table', 'thead', 'tbody', 'tr', 'th', 'td'
    ],
    ALLOWED_ATTR: ['href', 'title'],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false
  })
}
